import { render, staticRenderFns } from "./CreateRolePage.vue?vue&type=template&id=270fc121&"
import script from "./CreateRolePage.vue?vue&type=script&lang=js&"
export * from "./CreateRolePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports